import accessService from 'packages/services/accessControl';
import { EntityType } from 'packages/store/sharing/types';
import { catchResponseError } from 'packages/helpers/helpers';
import collectionsService from 'packages/services/collectionsService';
import * as types from '../types';

export function fetchCollection(id: any, withPermissions = false): any {
    return (dispatch, getState) => {
        dispatch({ type: types.COLLECTION_START_FETCH });

        if (withPermissions) {
            Promise.all([collectionsService.getCollection(id), accessService.getAccess([id], EntityType.COLLECTION)])
                .then(([{ status: statusData, collection }, { status: statusPermissions, json }]: any) => {
                    if (statusData === 200 && statusPermissions === 200) {
                        dispatch({
                            type: types.COLLECTION_SUCCESS_FETCH,
                            collection: { ...collection, grantedPermissions: json[0].entityGrantedPermissions },
                        });
                    } else {
                        dispatch({ type: types.COLLECTION_FAILURE_FETCH });
                    }
                })
                .catch(catchResponseError);
        } else {
            collectionsService
                .getCollection(id)
                .then(({ status, collection }) => {
                    if (status === 200) {
                        dispatch({
                            type: types.COLLECTION_SUCCESS_FETCH,
                            collection,
                        });
                    } else {
                        dispatch({ type: types.COLLECTION_FAILURE_FETCH });
                    }
                })
                .catch(catchResponseError);
        }
    };
}
